import React, { useEffect, useMemo, useState } from "react";
import api from "../../services/api";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
  Title,
} from "chart.js";

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend, Title);

export default function AdminAspirantsParRegionChart() {
  const [rows, setRows] = useState([]);
  const [parcours, setParcours] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  const fetchData = async () => {
    try {
      setLoading(true);
      setErr("");
      const params = new URLSearchParams();
      if (parcours) params.set("parcours", parcours);
      const url = `/adminStats/aspirants-per-region${params.toString() ? `?${params.toString()}` : ""}`;
      const res = await api.get(url);
      setRows(res.data || []);
    } catch (e) {
      console.error("Erreur /adminStats/aspirants-per-region:", e?.response || e);
      setErr(e?.response?.data?.error || "Erreur de chargement");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchData(); }, [parcours]);

  const labels = useMemo(() => rows.map(r => r.region_name ?? `Région ${r.region_id}`), [rows]);
  const values = useMemo(() => rows.map(r => Number(r.total_aspirants || 0)), [rows]);

  const { bgColor, borderColor, label } = useMemo(() => {
    if (parcours === "CG") {
      return {
        bgColor: "rgba(0, 123, 255, 0.9)",    
        borderColor: "rgba(0, 123, 255, 1)",
        label: "Aspirants Chef Guide"
      };
    } else if (parcours === "SYL") {
      return {
        bgColor: "rgba(128, 0, 32, 0.9)",      
        borderColor: "rgba(128, 0, 32, 1)",
        label: "Aspirants Senior Youth Leader"
      };
    }
    return {
      bgColor: "rgba(108, 117, 125, 0.8)",     
      borderColor: "rgba(108, 117, 125, 1)",
      label: "Aspirants (tous parcours)"
    };
  }, [parcours]);

  const data = {
    labels,
    datasets: [
      {
        label,
        data: values,
        backgroundColor: bgColor,
        borderColor: borderColor,
        borderWidth: 1,
        hoverBackgroundColor: bgColor,
        hoverBorderColor: borderColor,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      title: { display: true, text: "Nombre d’aspirants par région" },
      legend: { display: true },
      tooltip: { mode: "index", intersect: false },
    },
    scales: {
      x: { ticks: { autoSkip: false } },
      y: { beginAtZero: true, precision: 0 },
    },
  };

  return (
    <div className="card shadow-sm mt-4">
      <div className="card-header bg-white text-dark d-flex align-items-center gap-2">
        <span className="me-auto">Aspirants par région</span>
        <select
          className="form-select form-select-sm w-auto"
          value={parcours}
          onChange={(e) => setParcours(e.target.value)}
        >
          <option value="">Tous</option>
          <option value="CG">Chef Guide</option>
          <option value="SYL">Senior Youth Leader</option>
        </select>
        <button className="btn btn-light btn-sm" onClick={fetchData} disabled={loading}>Actualiser</button>
      </div>
      <div className="card-body">
        {err ? (
          <div className="alert alert-danger">{err}</div>
        ) : loading ? (
          <div className="text-muted">Chargement…</div>
        ) : rows.length === 0 ? (
          <div className="text-muted">Aucune donnée.</div>
        ) : (
          <Bar data={data} options={options} />
        )}
      </div>
    </div>
  );
}
